// Operator exclusions for the availability (✨/❌) picker and gap detection.
// Ported verbatim from the legacy v5.5 artifact. See REBUILD-SPEC.md §5.
//
// Excluded tours are still LOADED and ASSIGNABLE and still get Notion pages
// mapped — they are only skipped from the ✨/❌ picker and from gap detection.
// Excluded set: PSCT History, FLG Mural, and 11:00 FLG Route 66.

/**
 * Tour-name + time exclusion. Ports the legacy `_notionExcluded(tour, hhmm)`
 * (~line 4151) verbatim. `tour` is the Notion TOUR label, `hhmm` is "HH:MM".
 */
export function notionExcluded(tour: string, hhmm: string): boolean {
  if (tour === "PSCT History") return true; // operator exclusion
  if (tour === "FLG Mural") return true; // operator exclusion
  if (tour === "FLG Route 66" && hhmm === "11:00") return true; // operator exclusion
  return false;
}

